import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";

// Category-page dead-end guard (Sep 2026): every service page offers a way
// back to the full catalog and into the existing quote/contact route.
export const ServiceHelpLinks = ({ className = "" }) => (
  <nav
    data-testid="service-help-links"
    aria-label="More services"
    className={`max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-10 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-10 text-sm ${className}`}
  >
    <Link
      to="/services"
      data-testid="service-help-all-services"
      className="inline-flex items-center gap-2 font-semibold text-white hover:text-[#FF6600] transition-colors"
    >
      <ArrowLeft className="w-4 h-4" /> View All Services
    </Link>
    <Link
      to="/contact"
      data-testid="service-help-request-quote"
      className="inline-flex items-center gap-2 text-[#A3A3A3] hover:text-[#FF6600] transition-colors"
    >
      Can't find what you need?{" "}
      <span className="font-semibold text-white">Request a Quote</span>
      <ArrowRight className="w-4 h-4" />
    </Link>
  </nav>
);
